import { css } from '@emotion/css';

export const inputCx = css`
  input.MuiInputBase-input {
    color: #5e5e5e;
    font-weight: 600;
  }

  div.MuiInputBase-root:before {
    border-color: #e0e0e0;
  }

  .MuiFormLabel-root.Mui-error {
    color: rgba(0, 0, 0, 0.6);
  }
`;
